// @ts-nocheck
class LoadingButton extends HTMLButtonElement {
  constructor() {
    super();
    
    // 创建加载指示器
    this.loadingSpinner = document.createElement('div');
    this.loadingSpinner.className = 'loading-overlay__spinner';
    this.loadingSpinner.innerHTML = `
      <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
      </svg>
    `;
    
    // 添加到按钮中
    this.appendChild(this.loadingSpinner);
    
    // 添加点击事件监听
    this.addEventListener('click', this.handleClick.bind(this));
  }
  
  handleClick() {
    if (this.classList.contains('loading')) return;
    
    // 设置加载状态
    this.setLoading(true);
    
    // 检查是否有自动重置属性
    const resetAfter = this.getAttribute('reset-after');
    if (resetAfter) {
      const timeout = parseInt(resetAfter) * 1000;
      setTimeout(() => {
        this.setLoading(false);
      }, timeout);
    }
  }
  
  setLoading(isLoading) {
    if (isLoading) {
      this.classList.add('loading');
    } else {
      this.classList.remove('loading');
    }
  }
}
customElements.define('loading-button', LoadingButton, { extends: 'button' });

class SlideCard extends HTMLElement {
	constructor() {
		super()
		this.init()

    this.onArrowClickListener = this.onArrowClick.bind(this)
	}

  attr(name) {
    return this.getAttribute(name)
  }

	init() {

    const desktopOption = {
      destroy: this.attr('slider-desktop-enabled') == 'false',
      gap: parseInt(this.attr('slider-desktop-gap')),
      padding: {
        left: this.attr('slider-desktop-padding-left'),
        right: this.attr('slider-desktop-padding-right')
      },
      pagination: this.attr('slider-desktop-use-pagination') == 'true'
    }

    const tabletOption = {
      destroy: desktopOption.destroy,
      gap: desktopOption.gap,
      padding: {
        left: desktopOption.padding.left,
        right: desktopOption.padding.right
      },
      pagination: desktopOption.pagination
    }

    if (this.attr('slider-desktop-use-auto-width') == 'true') {
      desktopOption.autoWidth = true
      tabletOption.autoWidth = true
    } else {
      desktopOption.perPage = parseInt(this.attr('slider-columns-desktop'))
      tabletOption.perPage = parseInt(this.attr('slider-columns-tablet'))
    }

    const mobileOption = {
      perPage: parseInt(this.attr('slider-columns-mobile')),
      destroy: this.attr('slider-mobile-enabled') == 'false',
      gap: parseInt(this.attr('slider-mobile-gap')),
      padding: {
        left: this.attr('slider-mobile-padding-left'),
        right: this.attr('slider-mobile-padding-right')
      },
      pagination: this.attr('slider-mobile-use-pagination') == 'true'
    }

    const slideOptions = {
      type: this.attr('slider-loop') == 'true' ? 'loop' : 'slide',
      autoplay: this.attr('slider-autoplay') == 'true',
      interval: parseInt(this.attr('slider-autoplay-sec')) * 1000,
      arrows: false,
      mediaQuery: 'min',
      breakpoints: {
        "0": mobileOption,
        "768": tabletOption,
        "1025": desktopOption
      }
    }

    this.splide = new Splide(this.querySelector('.splide'), slideOptions)
    this.splide.on('ready', this.onSliderReady.bind(this))
		this.splide.on('move', this.onSliderMove.bind(this))
    this.splide.mount()
	}

  connectedCallback() {
    this.querySelectorAll('.slide-arrow').forEach(btn => {
      btn.addEventListener('click', this.onArrowClickListener)
    })
  }

  disconnectedCallback() {
    this.querySelectorAll('.slide-arrow').forEach(btn => {
      btn.removeEventListener('click', this.onArrowClickListener)
    })
  }

  onArrowClick(e) {
    if (e.target.closest('.slide-arrow').hasAttribute('nav-left')) {
      this.splide.go('<')
    } else {
      this.splide.go('>')
    }
  }

  onSliderReady() {
    this.updateArrowStates()
  }
  
  onSliderMove() {
    this.updateArrowStates()
  }

  updateArrowStates() {
    const isLoop = this.splide.options.type == 'loop'
    
		// 处理上一个箭头状态
		const isStart = this.splide.index <= 0;
		const prevDisabled = isStart && !this.splide.options.rewind && !isLoop;
		this.querySelectorAll('.slide-arrow-left')?.forEach(item => {
      if (prevDisabled) {
        item.setAttribute('disabled', '')
      } else {
        item.removeAttribute('disabled')
      }
    })
		
		// 处理下一个箭头状态
		const isEnd = this.splide.index >= this.splide.Components.Controller.getEnd();
		const nextDisabled = isEnd && !this.splide.options.rewind && !isLoop;
		this.querySelectorAll('.slide-arrow-right')?.forEach(item => {
      if (nextDisabled) {
        item.setAttribute('disabled', '')
      } else {
        item.removeAttribute('disabled')
      }
    })
  }
}
customElements.define('slide-card', SlideCard);

class TabBanner extends HTMLElement {
  constructor() {
    super();
    this.onTabItemClickListener = this.onTabItemClick.bind(this);
    this.tabItems.forEach(item => {
      item.addEventListener('click', this.onTabItemClickListener);
    })
    this.initImageSlider()
  }

  get tabItems() {
    return Array.from(this.querySelectorAll('.tab-item'));
  }

  initImageSlider() {
    this.slider = new Splide(this.querySelector('.splide'), {
      perPage: 1,
      arrows: false,
      pagination: false,
      drag: false
    }).mount()
  }

  onTabItemClick(e) {
    const item = this.tabItems.find(item => item.classList.contains('active'))
    if (item != e.target) {
      item?.classList.remove('active');
      e.target.classList.add('active');
      const index = this.tabItems.findIndex(item => item == e.target);
      this.slider.go(index);
    }
  }
}
customElements.define('tab-banner', TabBanner);

/**
 * 此模块配合steps.liqud + steps.js使用，在Collapsible模式下且打开了【开启滚动切换模式】开关。
 * 利用gsap + ScrollTrigger实现滚动切换标签的效果。
 */
class StepsScroller extends HTMLElement {
  constructor() {
    super()
    this.style.display = 'block'

    // 每个step停留的时间
    this.durationPerStep = 500
    // 最后一个step停留的时间
    this.durationLastStep = this.durationPerStep * 0.6
    this.init()
  }

  init() {
    this.stepTotal = this.querySelectorAll('.steps__info .steps__step').length
    const allDuration = (this.stepTotal - 1) * this.durationPerStep + this.durationLastStep
    // 计算每个步骤的进度区间
    this.stepThresholds = this.calculateStepThresholds();

    ScrollTrigger.create({
      trigger: this,
      pin: true,
      start: "top top",
      end: "+=" + allDuration,
      scrub: 0.5,
      onUpdate: (self) => {
        const progress = self.progress;
        const currentIndex = this.getCurrentStepIndex(progress);
        this.updateActiveStep(currentIndex);
      }
    });
  }

  // 计算每个步骤的进度阈值
  calculateStepThresholds() {
    const thresholds = [];
    const totalDuration = (this.stepTotal - 1) * this.durationPerStep + this.durationLastStep;

    // 前n-1个步骤
    for (let i = 0; i < this.stepTotal - 1; i++) {
      thresholds.push((i + 1) * this.durationPerStep / totalDuration);
    }

    // 最后一个步骤的阈值是1.0
    thresholds.push(1.0);
    return thresholds;
  }

  // 根据progress获取当前步骤index
  getCurrentStepIndex(progress) {
    // 确保progress在[0,1]范围内
    progress = Math.max(0, Math.min(progress, 1));
    
    for (let i = 0; i < this.stepThresholds.length; i++) {
      if (progress < this.stepThresholds[i]) {
        return i;
      }
    }
    return this.stepTotal - 1; // 默认返回最后一个
  }

  // 根据index获取对应的progress值
  getProgressByIndex(index) {
    index = Math.max(0, Math.min(index, this.stepTotal - 1));
    
    // 第一个步骤的progress是0
    if (index === 0) return 0;
    
    // 最后一个步骤的progress是1
    if (index === this.stepTotal - 1) return 1;
    
    // 中间步骤的progress是对应的阈值减去半个区间
    // 这样可以确保滚动到步骤的中间位置
    const prevThreshold = index * this.durationPerStep / 
                         ((this.stepTotal - 1) * this.durationPerStep + this.durationLastStep);
    const nextThreshold = (index + 1) * this.durationPerStep / 
                         ((this.stepTotal - 1) * this.durationPerStep + this.durationLastStep);
    
    return (prevThreshold + nextThreshold) / 2;
  }

  // index - base on zero
  updateActiveStep(index) {
    this.querySelector(`.steps__info .steps__step:nth-child(${index + 1}) .step__toggle`)?.click()
  }
}
customElements.define('steps-scroller', StepsScroller)

class VideoHero1 extends HTMLElement {
  constructor() {
    super()
    this.contentElement = this.querySelector('.hero--content')
    this.contentVisible = false
    this.popupVideo = this.querySelector('.popup-video')

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this,
        pin: true,
        start: "top top",
        end: "+=3000",
        scrub: 0.5,
        onUpdate: (self) => {
          const progress = self.progress;
          if (progress >= 0.55 && progress <= 0.83) {
            this.setContentVisible(true)
          } else {
            this.setContentVisible(false)
          }
        }
      }
    })
    tl.to(this.querySelector('.hero--overlay'), { scale: 50, opacity: 0 })

    this.querySelector('button.watch').addEventListener('click', () => {
      this.setPopupVideoVisible(true)
    })
    this.popupVideo.querySelector('.close-button').addEventListener('click', () => {
      this.setPopupVideoVisible(false)
    })
  }

  setContentVisible(visible) {
    if (this.contentVisible == visible) {
      return
    }
    if (visible) {
      this.contentVisible = true
      gsap.to(this.contentElement, { y: 0, opacity: 1 })
    } else {
      this.contentVisible = false
      gsap.to(this.contentElement, { y: 50, opacity: 0 })
    }
  }

  setPopupVideoVisible(visible) {
    if (visible) {
      this.popupVideo.classList.remove('js-hidden')
      this.closest('.video-hero-section').style.zIndex = 99
      this.popupVideo.querySelector('video')?.play()
    } else {
      this.popupVideo.classList.add('js-hidden')
      this.closest('.video-hero-section').style.zIndex = 0
      this.popupVideo.querySelector('video')?.pause()
    }
  }
}
customElements.define('video-hero-1', VideoHero1)

class StickyAnchorBar extends HTMLElement {
  constructor() {
      super()

      // 锚标记ID
      this.anchorSections = []
      this.isMobileMedia = window.matchMedia('(max-width: 767px)')

      this.onAnchorItemClickListener = this.onAnchorItemClick.bind(this)
      this.onWindowScrolledListener = this.throttle(this.onWindowScrolled.bind(this));
      this.onAnchorListScrolledListener = this.throttle(this.onAnchorListScrolled.bind(this));


      this.anchorResizeObserver = new ResizeObserver(() => {
          this.onAnchorListScrolledListener()
      })

      this.initSectionIdMarker()
  }

  get header() {
      return document.querySelector('sticky-header')
  }

  get anchorIds() {
      const ids = []
      this.anchorItems.forEach(item => {
      if (item.dataset.anchorId) {
          ids.push(item.dataset.anchorId)
      }
      })
      return ids
  }
  
  get anchorList() {
      return this.querySelector('.anchor-list')
  }

  get anchorItems() {
      return Array.from(this.querySelectorAll('.anchor-list .anchor-item'))
  }

  get footer() {
      return document.querySelector('footer')
  }

  throttle(func, delay) {
      let lastCallTime = 0;
      let timeoutId = null;
      
      return function(...args) {
          const now = Date.now();
          const remainingTime = delay - (now - lastCallTime);
          
          clearTimeout(timeoutId);
          
          if (remainingTime <= 0) {
          // 如果距离上次执行已经超过delay时间，立即执行
          lastCallTime = now;
          func.apply(this, args);
          } else {
          // 否则设置定时器，在剩余时间后执行
          timeoutId = setTimeout(() => {
              lastCallTime = Date.now();
              func.apply(this, args);
          }, remainingTime);
          }
      };
  }

  connectedCallback() {
      this.onAnchorListScrolled()
      this.anchorItems.forEach(item => {
          if (item.dataset.anchorId) {
              item.addEventListener('click', this.onAnchorItemClickListener)
          }
      })

      window.addEventListener('scroll', this.onWindowScrolledListener)
      this.anchorList.addEventListener('scroll', this.onAnchorListScrolledListener)

      this.anchorResizeObserver.observe(this.anchorList)
  }

  disconnectedCallback() {
      this.anchorItems.forEach(item => {
          item.removeEventListener('click', this.onAnchorItemClickListener)
      })
      window.removeEventListener('scroll', this.onWindowScrolledListener)
      this.anchorList.removeEventListener('scroll', this.onAnchorListScrolledListener)

      this.anchorResizeObserver.disconnect()
  }

  // 将shopify-section打上锚标记
  initSectionIdMarker() {
      if (this.anchorIds.length === 0) {
          return
      }
      const anchorSections = []
      for (const anchorId of this.anchorIds) {
          const sectionAnchor = document.querySelector(`[anchor-id="${anchorId}"]`)
          if (sectionAnchor) {
              let section
              if (sectionAnchor.classList.contains('sticky-anchor')) {
                  section = sectionAnchor?.closest('.shopify-section')?.nextElementSibling
              } else {
                  section = sectionAnchor?.closest('.shopify-section')
              }
              if (section) {
                  section.setAttribute('section-anchor-id', anchorId)
                  anchorSections.push(section)
              }
          }
      }
      this.anchorSections = anchorSections
  }

  onAnchorItemClick(e) {
      const anchor = e.target.dataset.anchorId
      const scrollView = this.anchorSections.find(item => item.getAttribute('section-anchor-id') == anchor)
      if (scrollView) {
          const offset = this.getBoundingClientRect().height
          let elementPosition = scrollView.getBoundingClientRect().top;
          let offsetPosition = elementPosition + window.scrollY - offset;
          window.scrollTo({top: offsetPosition, behavior: "smooth"})
      }
  }

  onWindowScrolled() {
      this.onScrolledForAuto()
      this.onScrolledToFindMatchSection()
  }

  /**
   * 滚动网页时，找到anchor item对应的模块，如果找到就将anchor item激活
   */
  onScrolledToFindMatchSection() {
      let barHeight = this.getBoundingClientRect().height
      
      const visibleSection = this.anchorSections.find(section => {
          const rect = section.getBoundingClientRect();
          return rect.top - barHeight <= 20 && rect.bottom - barHeight >= 80;
      });
      this.anchorItems.forEach(item => item.classList.remove('active'));
      const sectionAnchorId = visibleSection?.getAttribute('section-anchor-id');
      if (sectionAnchorId) {
          this.anchorItems.find(item => item.dataset.anchorId === sectionAnchorId)?.classList.add('active');
      }
  }

  onScrolledForAuto() {
      const rect = this.getBoundingClientRect()
      const top = rect.top
      const bottom = rect.bottom
      const hideHeader = top <= 20
      
      if (hideHeader) {
          this.header.style.visibility = 'hidden'
          if (!this.classList.contains('pin')) {
              this.classList.add('pin')
          }
          const positionTop = Math.max(0, this.header.getBoundingClientRect().bottom) - 2
          this.style.setProperty('--sticky-bar-top', `0px`)
      } else {
          this.header.style.visibility = 'visible'
          this.classList.remove('pin')
      }
      
  }

  onAnchorListScrolled() {
      if (this.anchorList.scrollWidth <= this.anchorList.clientWidth) {
          this.setAttribute('anchor-scroll-pos', 'none')
      } else if (this.anchorList.scrollLeft <= 0) {
          this.setAttribute('anchor-scroll-pos', 'left')
      } else if(this.anchorList.scrollLeft + this.anchorList.clientWidth >= this.anchorList.scrollWidth) {
          this.setAttribute('anchor-scroll-pos', 'right')
      } else {
          this.setAttribute('anchor-scroll-pos', 'center')
      }
  }
}
customElements.define('sticky-anchor-bar', StickyAnchorBar)

class SlideshowV2 extends HTMLElement {
  constructor() {
    super();
    this.isMobileMedia = window.matchMedia('(max-width: 767px)')

    this.sliderElement = this.querySelector('.splide')

    const options = {
      perPage: 1,
      gap: 0,
      padding: 0,
      arrows: this.hasAttribute('navigation'),
      pagination: this.hasAttribute('pagination')
    }
    if (this.dataset.autoplay === 'true') {
      options.autoplay = true
      options.interval = parseInt(this.dataset.autoplaySpeed || '5') * 1000
      options.type = 'loop'
    }

    this.slider = new Splide(this.sliderElement, options)
    this.slider.on('ready', this.onSliderReady.bind(this))
    this.slider.on('move', this.onSlideItemStartChange.bind(this))
    this.slider.on('moved', this.onSlideItemChanged.bind(this))
    this.slider.mount()
  }

  connectedCallback() {
    
  }

  onSliderReady() {
    this.onSlideItemChanged(0)
  }

  onSlideItemStartChange() {
    this.sliderElement.querySelectorAll('.slideshow__item responsive-video').forEach(vm => {
      vm.pause()
    })
  }

  onSlideItemChanged(newIndex, prevIndex, destIndex) {
    const index = destIndex || newIndex
    const videoMedia = this.sliderElement.querySelector(`.splide__slide:nth-child(${index + 1}) .slideshow__item responsive-video`)
    videoMedia?.play()
  }
}
customElements.define('slideshow-v2', SlideshowV2)

class JxsImageGrid extends HTMLElement {
  constructor() {
    super()

    const onImageItemClickListener = this.onImageItemClick.bind(this)
    this.querySelectorAll('.image-item').forEach(item => {
      item.addEventListener('click', onImageItemClickListener)
    })
  }

  onImageItemClick(e) {
    const item = e.target.closest('.image-item')
    console.log(item)
    const dialog = item.querySelector('modal-dialog')
    console.log(dialog)
    if (dialog) {
      dialog.show(item)
    }
  }
}
customElements.define('jxs-image-grid', JxsImageGrid);

class JxsIconTextPopupContainer extends HTMLElement {
  constructor() {
    super()

    let nextElement = this.nextElementSibling;
    
    while (nextElement && nextElement.tagName.toLowerCase() === 'jxs-icon-text-popup') {
      const popup = nextElement;
      nextElement = nextElement.nextElementSibling;
      this.appendChild(popup);
    }
  }
}
customElements.define('jxs-icon-text-popup-container', JxsIconTextPopupContainer);

class JxsProductDiscount extends HTMLElement {
  constructor() {
    super()

    this.querySelector('button').addEventListener('click', async (e) => {
      if (this.clearTimeoutId) {
        clearTimeout(this.clearTimeoutId)
        this.clearTimeoutId = null
      }
      const code = e.target.dataset.code
      try {
        await navigator.clipboard.writeText(code)
        e.target.textContent = 'COPIED'
        this.clearTimeoutId = setTimeout(() => {
          e.target.textContent = 'COPY'
        }, 3000)
      } catch (err) {
        console.error('复制失败:', err)
      }
    })
  }
}
customElements.define('jxs-product-discount', JxsProductDiscount);

class JxsTextExpand extends HTMLElement {
  constructor() {
    super()
    if (!this.hasAttribute('disabled')) {
      const expandWrapper = document.createElement('div')
      expandWrapper.classList.add('expand-wrapper')
      expandWrapper.innerHTML = '<span>View More</span><svg viewBox="0 0 1036 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M1020.403079 280.746102 969.751469 230.094492 507.243673 692.603311 54.205553 239.565191 3.553942 290.216801 507.243673 793.904485Z" fill="currentColor"></path></svg>'
      this.appendChild(expandWrapper)
  
      expandWrapper.addEventListener('click', () => {
        this.classList.toggle('open')
      })
    }
  }
}
customElements.define('jxs-text-expand', JxsTextExpand);

class JxsProductMediaContainer extends HTMLElement {
  constructor() {
    super()
    this.onTabClickListener = this.onTabClick.bind(this)
    this.currentPlayingVideo = null
    this.init()
  }

  get tabs() {
    return Array.from(this.querySelectorAll('.media-tab'))
  }

  get wrappers() {
    return Array.from(this.querySelectorAll('.product__media-wrapper'))
  }

  get allVideos() {
    return Array.from(this.querySelectorAll('video, responsive-video'))
  }

  init() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', this.onTabClickListener)
    })
  }

  connectedCallback() {
  }

  disconnectedCallback() {
    this.tabs.forEach(tab => {
      tab.removeEventListener('click', this.onTabClickListener)
    })
    // 暂停所有视频
    this.pauseAllVideos()
  }

  onTabClick(e) {
    const tab = e.currentTarget
    const mediaType = tab.getAttribute('media-type') || tab.getAttribute('type')

    // 移除所有tab的active状态
    this.tabs.forEach(t => t.classList.remove('active'))
    // 添加当前tab的active状态
    tab.classList.add('active')

    // 显示对应内容
    this.showContent(mediaType)
  }

  pauseAllVideos() {
    this.allVideos.forEach(video => {
      if (typeof video.pause === 'function') {
        video.pause()
        if (this.currentPlayingVideo === video) {
          this.currentPlayingVideo = null
        }
      }
    })
  }

  playVisibleVideos(container) {
    // 暂停之前播放的视频
    if (this.currentPlayingVideo && typeof this.currentPlayingVideo.pause === 'function') {
      this.currentPlayingVideo.pause()
    }

    // 获取当前可见容器中的视频
    const videosInContainer = container.querySelectorAll('video, responsive-video')
    
    if (videosInContainer.length > 0) {
      // 只自动播放第一个视频
      const firstVideo = videosInContainer[0]
      if (typeof firstVideo.play === 'function') {
        firstVideo.play()
          .catch(err => {
            // 自动播放可能被浏览器策略阻止，忽略错误
            console.log('Auto-play prevented:', err)
          })
        this.currentPlayingVideo = firstVideo
      } else if (typeof firstVideo === 'object' && firstVideo.nodeName === 'RESPONSIVE-VIDEO') {
        // 处理自定义元素 responsive-video
        if (typeof firstVideo.play === 'function') {
          firstVideo.play()
          this.currentPlayingVideo = firstVideo
        }
      }
    }
  }

  showContent(mediaType) {
    // 隐藏所有内容并暂停视频
    this.wrappers.forEach(wrapper => {
      if (!wrapper.classList.contains('active')) return
      
      // 如果切换离开视频容器，暂停容器中正在播放的视频
      if (wrapper.getAttribute('media-type') === 'video') {
        const videos = wrapper.querySelectorAll('video, responsive-video')
        videos.forEach(video => {
          if (typeof video.pause === 'function') {
            video.pause()
            if (this.currentPlayingVideo === video) {
              this.currentPlayingVideo = null
            }
          }
        })
      }
      wrapper.classList.remove('active')
    })

    // 显示对应类型的内容
    const targetWrapper = this.wrappers.find(wrapper => 
      wrapper.getAttribute('media-type') === mediaType
    )
    const swiperEl = targetWrapper?.querySelector('.js-media-list')
    
    if (targetWrapper) {
      targetWrapper.classList.add('active')

      if (swiperEl?.swiper) {
        swiperEl.swiper.update()
        if (mediaType === 'video') {
          const videoSlideIndex = Array.from(swiperEl.swiper.slides).findIndex((slide) =>
            slide.querySelector('deferred-media, video, responsive-video')
          )
          if (videoSlideIndex >= 0) {
            swiperEl.swiper.slideTo(videoSlideIndex, 0)
          }
        }
      }
      
      // 如果切换到视频选项卡，自动播放第一个视频
      if (mediaType === 'video') {
        this.playVisibleVideos(targetWrapper)
      }
    }
  }
}
customElements.define('jxs-product-media-container', JxsProductMediaContainer);


class JxsStickyBuy extends HTMLElement {
  constructor() {
    super()
    this.add2CartButton = this.querySelector('button[name="add2cart"]')
    this.add2CartButton.addEventListener('click', this.onAdd2CartClick.bind(this))
    this.querySelector('button[name="checkout"]').addEventListener('click', this.onExpressBuyClick.bind(this))

    subscribe('productAdd2Cart', this.onProductAdd2Cart.bind(this))

    this.initScrollAction()
  }

  initScrollAction() {
    this.scopeFrom = document.querySelector('.product__buy-buttons');
    this.scopeTo = document.querySelector('footer');

    if (!this.scopeFrom || !this.scopeTo) {
      return;
    }

    const intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this));
    intersectionObserver.observe(this.scopeFrom);
    intersectionObserver.observe(this.scopeTo);
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.target === this.scopeFrom) {
        this.scopeFromPassed = entry.boundingClientRect.bottom < 0;
      }
      if (entry.target === this.scopeTo) {
        this.scopeToReached = entry.isIntersecting;
      }
    });

    if (this.scopeFromPassed && !this.scopeToReached) {
      this.setAttribute('visible', 'true')
    } else {
      this.setAttribute('visible', 'false')
    }
  }

  onExpressBuyClick() {
    window.location.href = '/checkout'
  }

  onAdd2CartClick() {
    if (this.add2CartButton.getAttribute('aria-disabled') === 'true') return;
    this.add2CartButton.setAttribute('aria-disabled', true);
    this.add2CartButton.classList.add('loading');
    this.add2CartButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    document.querySelector('.product-form__buttons button[name="add"]')?.click()
  }

  onProductAdd2Cart() {
    this.add2CartButton.setAttribute('aria-disabled', false);
    this.add2CartButton.classList.remove('loading');
    this.add2CartButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
  }
}
customElements.define('jxs-sticky-buy', JxsStickyBuy);

class JxsArticleIndex extends HTMLElement {
  constructor() {
    super();
    this.tocList = this.querySelector('.blog-aside__article-index-list');
  }

  connectedCallback() {
    // 等待DOM完全加载后生成目录
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.generateTOC());
    } else {
      this.generateTOC();
    }
    this.querySelector('.expand-handle').addEventListener('click', this.#onExpandClick)
  }

  disconnectedCallback() {
    this.querySelector('.expand-handle').removeEventListener('click', this.#onExpandClick)
  }


  generateTOC() {
    // 查找文章内容容器
    const contentContainer = document.querySelector('.article-template__content-rte');
    
    if (!contentContainer || !this.tocList) {
      return;
    }

    const headings = contentContainer.querySelectorAll(this.dataset.indexTarget);
    
    if (headings.length === 0) {
      return;
    }

    // 清空现有内容
    this.tocList.innerHTML = '';

    // 处理每个标题
    headings.forEach((heading) => {
      // 生成随机ID（如果没有）
      let headingId = heading.id;
      if (!headingId) {
        headingId = this.generateRandomId();
        heading.id = headingId;
      }

      // 创建目录链接
      const link = document.createElement('a');
      link.href = '#' + headingId;
      link.textContent = heading.textContent.trim();
      link.className = 'blog-aside__article-index-link';
      
      // 添加点击事件实现平滑滚动
      link.addEventListener('click', (e) => {
        e.preventDefault();
        this.smoothScrollTo(document.getElementById(headingId));
        
        // 更新URL哈希值
        if (history.pushState) {
          history.pushState(null, null, '#' + headingId);
        } else {
          location.hash = '#' + headingId;
        }
      });

      this.tocList.appendChild(link);
    });
  }

  // 生成随机ID
  generateRandomId() {
    return 'toc-' + Math.random().toString(36).substr(2, 9);
  }

  // 平滑滚动到元素
  smoothScrollTo(element) {
    if (!element) return;
    
    const offsetTop = element.getBoundingClientRect().top + window.pageYOffset;
    const headerOffset = 80; // 根据header高度调整
    
    window.scrollTo({
      top: offsetTop - headerOffset,
      behavior: 'smooth'
    });
  }

  #onExpandClick = () => {
    this.classList.toggle('expanded')
  }
}
customElements.define('jxs-article-index', JxsArticleIndex);